module.exports = __webpack_public_path__ + "media/images/views/job/coin-ab757bc9a56d58149b9615e100fb559e.png";